import React from "react";
import { Radio, Space, DatePicker, Form } from "antd";
import { DATE_FORMAT_MM, disableFutureDates } from "library/helpers/utils";
import { TimeFilterWrapper } from "./styles";
const { RangePicker } = DatePicker;

const TimeFrameComponent = ({
  selectedDateRange,
  handleDateRangeChange,
  handleCustomDateChange,
}: any) => {
  const timeframeOptions = [
    { label: "Today", value: "today" },
    { label: "Last 7 Days", value: "last7days" },
    { label: "This Month", value: "thisMonth" },
    { label: "Last Month", value: "lastMonth" },
    { label: "Custom", value: "custom" },
  ];
  return (
    <TimeFilterWrapper>
      <Space size="small" style={{marginLeft: "10px"}}>
        <span>Time Frame</span>
        <Radio.Group
          options={timeframeOptions}
          value={selectedDateRange}
          onChange={handleDateRangeChange}
          optionType="button"
          buttonStyle="solid"
        />
        {selectedDateRange === "custom" && (
          <Form.Item
            name="startEndDate"
            label="Date Range"
            rules={[
              {
                required: true,
                message: "Please select start & end date",
              },
            ]}
            style={{ marginLeft: "10px",  marginTop:"-5px" }}
          >
            <RangePicker
              inputReadOnly={true}
              format={DATE_FORMAT_MM}
              onChange={handleCustomDateChange}
              disabledDate={disableFutureDates}
            />
          </Form.Item>
        )}
      </Space>
    </TimeFilterWrapper>
  );
};

export default React.memo(TimeFrameComponent);
